import React, { PropTypes } from 'react';
import sortBy from 'lodash/sortBy';
import truncate from 'lodash/truncate';
import moment from 'moment';
import StarRating from 'common/components/star_rating';

const RevisionVotes = ({ revision }) => {
  const votesByDate = sortBy(Object.values(revision.votes), (v) => -moment(v.created_at).unix());

  return (
    <table className="table table-default">
      <thead>
        <tr>
          <td>Email</td>
          <td className="hide-for-small-only">Name</td>
          <td>Vote</td>
          <td className="hide-for-small-only">Vote Date</td>
        </tr>
      </thead>
      <tbody>
        { votesByDate.map((vote, i) => (
        <tr key={i}>
          <td>{ truncate(vote.participant_email, { length: 20 }) }</td>
          <td className="hide-for-small-only">
            { truncate(vote.participant_name || '', { length: 10 }) }
          </td>
          <td>
            <StarRating readonly={true} initialRate={vote.score}/>
          </td>
          <td className="hide-for-small-only">{ moment(vote.created_at).fromNow() }</td>
        </tr>
        )) }
      </tbody>
    </table>
  );
}

RevisionVotes.propTypes = {
  revision: PropTypes.object.isRequired,
};

export default RevisionVotes;



// WEBPACK FOOTER //
// ./presentations/components/revision_votes.jsx